import { main_energy_source_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateMainEnergySourceTypeEnum = (enumValue: main_energy_source_type_enum) => {
  switch (enumValue) {
    case main_energy_source_type_enum.DISTRICT_HEATING:
      return <Trans i18nKey="Enum_MainEnergySourceTypeEnum-DISTRICT_HEATING" />;
    case main_energy_source_type_enum.ELECTRICITY:
      return <Trans i18nKey="Enum_MainEnergySourceTypeEnum-ELECTRICITY" />;
    case main_energy_source_type_enum.GAS:
      return <Trans i18nKey="Enum_MainEnergySourceTypeEnum-GAS" />;
    case main_energy_source_type_enum.OIL:
      return <Trans i18nKey="Enum_MainEnergySourceTypeEnum-OIL" />;
    case main_energy_source_type_enum.OTHER:
      return <Trans i18nKey="Enum_MainEnergySourceTypeEnum-OTHER" />;
  }
};

export const translateMainEnergySourceTypeEnum_dynamic = (enumValue: main_energy_source_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case main_energy_source_type_enum.DISTRICT_HEATING:
      return t('Enum_MainEnergySourceTypeEnum-DISTRICT_HEATING');
    case main_energy_source_type_enum.ELECTRICITY:
      return t('Enum_MainEnergySourceTypeEnum-ELECTRICITY');
    case main_energy_source_type_enum.GAS:
      return t('Enum_MainEnergySourceTypeEnum-GAS');
    case main_energy_source_type_enum.OIL:
      return t('Enum_MainEnergySourceTypeEnum-OIL');
    case main_energy_source_type_enum.OTHER:
      return t('Enum_MainEnergySourceTypeEnum-OTHER');
  }
};
